import { getXStateConfigWoofz22V3 } from 'nove8/cohorts/woofz22_v3/getXStateConfigWoofz22V3'
import { getXStateConfigWoofz22V4 } from 'nove8/cohorts/woofz22_v4/getXStateConfigWoofz22V4'
import { getXStateConfigWoofz22V4Wt } from 'nove8/cohorts/woofz22_v4_wt/getXStateConfigWoofz22V4Wt'
import { getXStateConfigWoofz22V4Bg } from 'nove8/cohorts/woofz22_v4_bg/getXStateConfigWoofz22V4Bg'
import { getXStateConfigWoofz22V4L } from 'nove8/cohorts/woofz22_v4l/getXStateConfigWoofz22V4L'
import { getXStateConfigWoofz22V4t } from 'nove8/cohorts/woofz22_v4t/getXStateConfigWoofz22V4t'
import { getXStateConfigWoofz22V9 } from 'nove8/cohorts/woofz22_v9/getXStateConfigWoofz22V9'
import { getXStateConfigWoofzCoaching } from 'nove8/cohorts/woofz_coaching/getXStateConfigWoofzCoaching'
import { getXStateConfigWoofzEaster65 } from 'nove8/cohorts/woofz_easter/woofz_easter_65/getXStateConfigWoofzEaster65'
import { getXStateConfigWoofzEaster70 } from 'nove8/cohorts/woofz_easter/woofz_easter_70/getXStateConfigWoofzEaster70'
import { getXStateConfigWoofzEaster75 } from 'nove8/cohorts/woofz_easter/woofz_easter_75/getXStateConfigWoofzEaster75'
import { getXStateConfigWoofzEaster80 } from 'nove8/cohorts/woofz_easter/woofz_easter_80/getXStateConfigWoofzEaster80'
import { getXStateConfigWoofzEsa } from 'nove8/cohorts/woofz_esa/getXStateConfigWoofzEsa'
import { getXStateConfigWoofzHlwn65 } from 'nove8/cohorts/woofz_hlwn/woofz_hlwn_65/getXStateConfigWoofzHlwn65'
import { getXStateConfigWoofzHlwn70 } from 'nove8/cohorts/woofz_hlwn/woofz_hlwn_70/getXStateConfigWoofzHlwn70'
import { getXStateConfigWoofzHlwn75 } from 'nove8/cohorts/woofz_hlwn/woofz_hlwn_75/getXStateConfigWoofzHlwn75'
import { getXStateConfigWoofzHlwn80 } from 'nove8/cohorts/woofz_hlwn/woofz_hlwn_80/getXStateConfigWoofzHlwn80'
import { getXStateConfigWoofzInvx } from 'nove8/cohorts/woofz_invx/getXStateConfigWoofzInvx'
import { getXStateConfigWoofzK9 } from 'nove8/cohorts/woofz_k9/getXStateConfigWoofzK9'
import { getXStateConfigWoofzK9Bl } from 'nove8/cohorts/woofz_k9_bl/getXStateConfigWoofzK9Bl'
import { getXStateConfigWoofzK9BlBg } from 'nove8/cohorts/woofz_k9_bl_bg/getXStateConfigWoofzK9BlBg'
import { getXStateConfigWoofzK9Drsl } from 'nove8/cohorts/woofz_k9_drsl/getXStateConfigWoofzK9'
import { getXStateConfigWoofzLove } from 'nove8/cohorts/woofz_love/getXStateConfigWoofzLove'
import { getXStateConfigWoofzLoveBl } from 'nove8/cohorts/woofz_love_bl/getXStateConfigWoofzLoveBl'
import { getXStateConfigWoofzNdd65 } from 'nove8/cohorts/woofz_ndd/woofz_ndd_65/getXStateConfigWoofzNdd65'
import { getXStateConfigWoofzNdd70 } from 'nove8/cohorts/woofz_ndd/woofz_ndd_70/getXStateConfigWoofzNdd70'
import { getXStateConfigWoofzNdd75 } from 'nove8/cohorts/woofz_ndd/woofz_ndd_75/getXStateConfigWoofzNdd75'
import { getXStateConfigWoofzNdd80 } from 'nove8/cohorts/woofz_ndd/woofz_ndd_80/getXStateConfigWoofzNdd80'
import { getXStateConfigWoofzNdd } from 'nove8/cohorts/woofz_ndd/woofz_ndd_cohort/getXStateConfigWoofzNdd'
import { getXStateConfigWoofzNpday65 } from 'nove8/cohorts/woofz_npday/woofz_npday_65/getXStateConfigWoofzNpday65'
import { getXStateConfigWoofzNpday70 } from 'nove8/cohorts/woofz_npday/woofz_npday_70/getXStateConfigWoofzNpday70'
import { getXStateConfigWoofzNpday75 } from 'nove8/cohorts/woofz_npday/woofz_npday_75/getXStateConfigWoofzNpday75'
import { getXStateConfigWoofzNpday80 } from 'nove8/cohorts/woofz_npday/woofz_npday_80/getXStateConfigWoofzNpday80'
import { getXStateConfigWoofzNrday65 } from 'nove8/cohorts/woofz_nrday/woofz_nrday_65/getXStateConfigWoofzNrday65'
import { getXStateConfigWoofzNrday70 } from 'nove8/cohorts/woofz_nrday/woofz_nrday_70/getXStateConfigWoofzNrday70'
import { getXStateConfigWoofzNrday75 } from 'nove8/cohorts/woofz_nrday/woofz_nrday_75/getXStateConfigWoofzNrday75'
import { getXStateConfigWoofzNrday80 } from 'nove8/cohorts/woofz_nrday/woofz_nrday_80/getXStateConfigWoofzNrday80'
import { getXStateConfigWoofzOffer165 } from 'nove8/cohorts/woofz_offer/woofz_offer1_65/getXStateConfigWoofzOffer165'
import { getXStateConfigWoofzOffer170 } from 'nove8/cohorts/woofz_offer/woofz_offer1_70/getXStateConfigWoofzOffer170'
import { getXStateConfigWoofzOffer175 } from 'nove8/cohorts/woofz_offer/woofz_offer1_75/getXStateConfigWoofzOffer175'
import { getXStateConfigWoofzOffer180 } from 'nove8/cohorts/woofz_offer/woofz_offer1_80/getXStateConfigWoofzOffer180'
import { getXStateConfigWoofzOffer270 } from 'nove8/cohorts/woofz_offer/woofz_offer2_70/getXStateConfigWoofzOffer270'
import { getXStateConfigWoofzOffer275 } from 'nove8/cohorts/woofz_offer/woofz_offer2_75/getXStateConfigWoofzOffer275'
import { getXStateConfigWoofzPawNup } from 'nove8/cohorts/woofz_paw_nup/getXStateConfigWoofzPawNup'
import { getXStateConfigWoofzPn } from 'nove8/cohorts/woofz_pn/getXStateConfigWoofzPn'
import { getXStateConfigWoofzPpday65 } from 'nove8/cohorts/woofz_ppday/woofz_ppday_65/getXStateConfigWoofzPpday65'
import { getXStateConfigWoofzPpday70 } from 'nove8/cohorts/woofz_ppday/woofz_ppday_70/getXStateConfigWoofzPpday70'
import { getXStateConfigWoofzPpday75 } from 'nove8/cohorts/woofz_ppday/woofz_ppday_75/getXStateConfigWoofzPpday75'
import { getXStateConfigWoofzPpday80 } from 'nove8/cohorts/woofz_ppday/woofz_ppday_80/getXStateConfigWoofzPpday80'
import { getXStateConfigWoofzPpp } from 'nove8/cohorts/woofz_ppp/getXStateConfigWoofzPpp'
import { getXStateConfigWoofzPppBl } from 'nove8/cohorts/woofz_ppp_bl/getXStateConfigWoofzPppBl'
import { getXStateConfigWoofzPppWoofy } from 'nove8/cohorts/woofz_ppp_woofy/getXStateConfigWoofzPppWoofy'
import { getXStateConfigWoofzPt1 } from 'nove8/cohorts/woofz_pt1/getXStateConfigWoofzPt1'
import { getXStateConfigWoofzPt1Bg } from 'nove8/cohorts/woofz_pt1_bg/getXStateConfigWoofzPt1Bg'
import { getXStateConfigWoofzPup } from 'nove8/cohorts/woofz_pup/getXStateConfigWoofzPup'
import { getXStateConfigWoofzPupBl } from 'nove8/cohorts/woofz_pup_bl/getXStateConfigWoofzPupBl'
import { getXStateConfigWoofzPupDrsl } from 'nove8/cohorts/woofz_pup_drsl/getXStateConfigWoofzPupDrsl'
import { getXStateConfigWoofzPupWt } from 'nove8/cohorts/woofz_pup_wt/getXStateConfigWoofzPupWt'
import { getXStateConfigWoofzRfnd3 } from 'nove8/cohorts/woofz_rfnd3/getXStateConfigWoofzRfnd3'
import { getXStateConfigWoofzRfnd3Nd } from 'nove8/cohorts/woofz_rfnd3_nd/getXStateConfigWoofzRfnd3Nd'
import { getXStateConfigWoofzRt } from 'nove8/cohorts/woofz_rt/getXStateConfigWoofzRt'
import { getXStateConfigWoofzS1612 } from 'nove8/cohorts/woofz_s/woofz_s1_6_12/getXStateConfigWoofzS1612'
import { getXStateConfigWoofzS2612 } from 'nove8/cohorts/woofz_s/woofz_s2_6_12/getXStateConfigWoofzS2612'
import { getXStateConfigWoofzS3612 } from 'nove8/cohorts/woofz_s/woofz_s3_6_12/getXStateConfigWoofzS3612'
import { getXStateConfigWoofzSmd } from 'nove8/cohorts/woofz_smd/getXStateConfigWoofzSmd'
import { getXStateConfigWoofzSmdBl } from 'nove8/cohorts/woofz_smd_bl/getXStateConfigWoofzSmdBl'
import { getXStateConfigWoofzSubCnld70 } from 'nove8/cohorts/woofz_sub_cnld_70/getXStateConfigWoofzSubCnld70'
import { getXStateConfigWoofzVc6 } from 'nove8/cohorts/woofz_vc6/getXStateConfigWoofzVc6'
import { getXStateConfigWoofzVday65 } from 'nove8/cohorts/woofz_vday/woofz_vday_65/getXStateConfigWoofzVday65'
import { getXStateConfigWoofzVday70 } from 'nove8/cohorts/woofz_vday/woofz_vday_70/getXStateConfigWoofzVday70'
import { getXStateConfigWoofzVday75 } from 'nove8/cohorts/woofz_vday/woofz_vday_75/getXStateConfigWoofzVday75'
import { getXStateConfigWoofzVday80 } from 'nove8/cohorts/woofz_vday/woofz_vday_80/getXStateConfigWoofzVday80'
import { getXStateConfigWoofzVgs } from 'nove8/cohorts/woofz_vgs/getXStateConfigWoofzVgs'
import { getXStateConfigWoofzWa1 } from 'nove8/cohorts/woofz_wa1/getXStateConfigWoofzWa1'
import { getXStateConfigWoofzWoofy } from 'nove8/cohorts/woofz_woofy1/getXStateConfigWoofzWoofy'
import { getXStateConfigWoofzWS2 } from 'nove8/cohorts/woofz_ws2/getXStateConfigWoofzWs2'
import { getXStateConfigWoofzXmas65 } from 'nove8/cohorts/woofz_xmas/woofz_xmas_65/getXStateConfigWoofzXmas65'
import { getXStateConfigWoofzXmas70 } from 'nove8/cohorts/woofz_xmas/woofz_xmas_70/getXStateConfigWoofzXmas70'
import { getXStateConfigWoofzXmas80 } from 'nove8/cohorts/woofz_xmas/woofz_xmas_80/getXStateConfigWoofzXmas80'
import { TStep } from 'nove8/types'
import { StatesConfig } from 'xstate'
import { Cohort } from './root-constants'

export const XSTATE_CONFIGS_MAP: Record<
  Cohort,
  (pages: TStep[]) => StatesConfig<any, any, any>
> = {
  [Cohort.WOOFZ22_V9]: getXStateConfigWoofz22V9,
  [Cohort.WOOFZ22_V4L]: getXStateConfigWoofz22V4L,
  [Cohort.WOOFZ_PN]: getXStateConfigWoofzPn,
  [Cohort.WOOFZ_ESA]: getXStateConfigWoofzEsa,
  [Cohort.WOOFZ_WS2]: getXStateConfigWoofzWS2,
  [Cohort.WOOFZ_VGS]: getXStateConfigWoofzVgs,
  [Cohort.WOOFZ_RFND3_ND]: getXStateConfigWoofzRfnd3Nd,
  [Cohort.WOOFZ_VC6]: getXStateConfigWoofzVc6,
  [Cohort.WOOFZ22_V3]: getXStateConfigWoofz22V3,
  [Cohort.WOOFZ_PT1]: getXStateConfigWoofzPt1,
  [Cohort.WOOFZ22_V4]: getXStateConfigWoofz22V4,
  [Cohort.WOOFZ_RFND3]: getXStateConfigWoofzRfnd3,
  [Cohort.WOOFZ_PPP]: getXStateConfigWoofzPpp,
  [Cohort.WOOFZ_PPP_BL]: getXStateConfigWoofzPppBl,
  [Cohort.WOOFZ_PPP_WOOFY]: getXStateConfigWoofzPppWoofy,
  [Cohort.WOOFZ_PUP]: getXStateConfigWoofzPup,
  [Cohort.WOOFZ_PUP_BL]: getXStateConfigWoofzPupBl,
  [Cohort.WOOFZ_LOVE]: getXStateConfigWoofzLove,
  [Cohort.WOOFZ_RT]: getXStateConfigWoofzRt,
  [Cohort.WOOFZ22_V4T]: getXStateConfigWoofz22V4t,
  [Cohort.WOOFZ_LOVE_BL]: getXStateConfigWoofzLoveBl,
  [Cohort.WOOFZ_INVX]: getXStateConfigWoofzInvx,
  [Cohort.WOOFZ_EASTER_65]: getXStateConfigWoofzEaster65,
  [Cohort.WOOFZ_EASTER_70]: getXStateConfigWoofzEaster70,
  [Cohort.WOOFZ_EASTER_75]: getXStateConfigWoofzEaster75,
  [Cohort.WOOFZ_EASTER_80]: getXStateConfigWoofzEaster80,
  [Cohort.WOOFZ_S1_6_12]: getXStateConfigWoofzS1612,
  [Cohort.WOOFZ_S2_6_12]: getXStateConfigWoofzS2612,
  [Cohort.WOOFZ_S3_6_12]: getXStateConfigWoofzS3612,
  [Cohort.WOOFZ_K9]: getXStateConfigWoofzK9,
  [Cohort.WOOFZ_NPDAY_65]: getXStateConfigWoofzNpday65,
  [Cohort.WOOFZ_NPDAY_70]: getXStateConfigWoofzNpday70,
  [Cohort.WOOFZ_NPDAY_75]: getXStateConfigWoofzNpday75,
  [Cohort.WOOFZ_NPDAY_80]: getXStateConfigWoofzNpday80,
  [Cohort.WOOFZ_K9_BL]: getXStateConfigWoofzK9Bl,
  [Cohort.WOOFZ_K9_BL_1]: getXStateConfigWoofzK9Bl, // OCS testing cohort
  [Cohort.WOOFZ_K9_BL_2]: getXStateConfigWoofzK9Bl, // OCS testing cohort
  [Cohort.WOOFZ_K9_BL_3]: getXStateConfigWoofzK9Bl, // OCS testing cohort
  [Cohort.WOOFZ_K9_DRSL]: getXStateConfigWoofzK9Drsl,
  [Cohort.WOOFZ_PPDAY_65]: getXStateConfigWoofzPpday65,
  [Cohort.WOOFZ_XMAS_65]: getXStateConfigWoofzXmas65,
  [Cohort.WOOFZ_XMAS_70]: getXStateConfigWoofzXmas70,
  [Cohort.WOOFZ_XMAS_80]: getXStateConfigWoofzXmas80,
  [Cohort.WOOFZ_PPDAY_70]: getXStateConfigWoofzPpday70,
  [Cohort.WOOFZ_PPDAY_75]: getXStateConfigWoofzPpday75,
  [Cohort.WOOFZ_PPDAY_80]: getXStateConfigWoofzPpday80,
  [Cohort.WOOFZ_WA1]: getXStateConfigWoofzWa1,
  [Cohort.WOOFZ_OFFER1_65]: getXStateConfigWoofzOffer165,
  [Cohort.WOOFZ_OFFER1_70]: getXStateConfigWoofzOffer170,
  [Cohort.WOOFZ_OFFER1_75]: getXStateConfigWoofzOffer175,
  [Cohort.WOOFZ_OFFER1_80]: getXStateConfigWoofzOffer180,
  [Cohort.WOOFZ_OFFER2_70]: getXStateConfigWoofzOffer270,
  [Cohort.WOOFZ_OFFER2_75]: getXStateConfigWoofzOffer275,
  [Cohort.WOOFZ_VDAY_65]: getXStateConfigWoofzVday65,
  [Cohort.WOOFZ_VDAY_70]: getXStateConfigWoofzVday70,
  [Cohort.WOOFZ_VDAY_75]: getXStateConfigWoofzVday75,
  [Cohort.WOOFZ_VDAY_80]: getXStateConfigWoofzVday80,
  [Cohort.WOOFZ_HLWN_65]: getXStateConfigWoofzHlwn65,
  [Cohort.WOOFZ_HLWN_70]: getXStateConfigWoofzHlwn70,
  [Cohort.WOOFZ_HLWN_75]: getXStateConfigWoofzHlwn75,
  [Cohort.WOOFZ_HLWN_80]: getXStateConfigWoofzHlwn80,
  [Cohort.WOOFZ_SUB_CNLD_70]: getXStateConfigWoofzSubCnld70,
  [Cohort.WOOFZ_NDD]: getXStateConfigWoofzNdd,
  [Cohort.WOOFZ_NDD_65]: getXStateConfigWoofzNdd65,
  [Cohort.WOOFZ_NDD_70]: getXStateConfigWoofzNdd70,
  [Cohort.WOOFZ_NDD_75]: getXStateConfigWoofzNdd75,
  [Cohort.WOOFZ_NDD_80]: getXStateConfigWoofzNdd80,
  [Cohort.WOOFZ_WOOFY1]: getXStateConfigWoofzWoofy,
  [Cohort.WOOFZ_NRDAY_65]: getXStateConfigWoofzNrday65,
  [Cohort.WOOFZ_NRDAY_70]: getXStateConfigWoofzNrday70,
  [Cohort.WOOFZ_NRDAY_75]: getXStateConfigWoofzNrday75,
  [Cohort.WOOFZ_NRDAY_80]: getXStateConfigWoofzNrday80,
  [Cohort.WOOFZ_PUP_WT]: getXStateConfigWoofzPupWt,
  [Cohort.WOOFZ_PUP_DRSL]: getXStateConfigWoofzPupDrsl,
  [Cohort.WOOFZ_COACHING]: getXStateConfigWoofzCoaching,
  [Cohort.WOOFZ_SMD]: getXStateConfigWoofzSmd,
  [Cohort.WOOFZ_SMD_BL]: getXStateConfigWoofzSmdBl,
  [Cohort.WOOFZ_PAW_NUP]: getXStateConfigWoofzPawNup,
  [Cohort.WOOFZ22_V4_WT]: getXStateConfigWoofz22V4Wt,
  [Cohort.WOOFZ22_V4_BG]: getXStateConfigWoofz22V4Bg,
  [Cohort.WOOFZ_PT1_BG]: getXStateConfigWoofzPt1Bg,
  [Cohort.WOOFZ_K9_BL_BG]: getXStateConfigWoofzK9BlBg,
}
